import { render, staticRenderFns } from "./TariffCalculatorConsumptionSlider.vue?vue&type=template&id=cd35bef4&"
import script from "./TariffCalculatorConsumptionSlider.vue?vue&type=script&lang=ts&"
export * from "./TariffCalculatorConsumptionSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports